import React from "react";
import "./BillTotal.css";

export default function BillTotal(props) {
  return (
    <div>
      <div className="total-container">
        <div className="total">
          <div className="total-title">
            <h3>Tip Amount</h3>
            <h4>/ person</h4>
          </div>
          <div className="total-number">${props.tipAmount}</div>
        </div>

        <div className="total">
          <div className="total-title">
            <h3>Total</h3>
            <h4>/ person</h4>
          </div>
          <div className="total-number">${props.billTotalRunnig}</div>
        </div>

        <div className="total-reset">
          <button onClick={props.onReset}>RESET</button>
        </div>
      </div>
    </div>
  );
}
